import React from 'react'
import { FaCheck, FaTimes } from 'react-icons/fa'

export function YesNoRendererComponent({ value }: any) {
  return (
    <>
      <div>
        {value === true && <FaCheck style={{ color: 'green', padding: 0, margin: 0 }} />}
        {value === false && <FaTimes style={{ color: 'red', padding: 0, margin: 0 }} />}
      </div>
    </>
  )
}
